/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useSpring } from 'react-spring';

export const useNotificationsPanelAnimation = (open: boolean) => useSpring({
    opacity: open ? 1 : 0,
    transform: open
      ? 'translateY(0px) scale(1)'
      : 'translateY(-8px) scale(0.98)',
    config: {
      tension: 260,
      friction: 20,
    },
  });